import { type ReactNode } from 'react';
import useObservable from 'react-use/esm/useObservable';
import { makeStyles } from 'tss-react/mui';
import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';
import { getColors, typography } from '@mercedes-benz/odp-theme-v2';

const useStyles = makeStyles<{ isV2Theme: boolean }>()((
  theme,
  { isV2Theme },
) => {
  const c = getColors(theme.palette.mode);
  return {
    root: {
      background: c.background.paper,
      borderRadius: 12,
      border: `1px solid ${c.border.default}`,
      overflow: 'hidden',
      // Only force v2 fonts and colors when using classic theme with catalogV2.
      // When actual v2 theme is active, let it handle colors natively.
      ...(!isV2Theme && {
        '& *': {
          fontFamily: `${typography.fontFamily} !important`,
          color: `${c.text.primary} !important`,
        },
        '& a, & a *': {
          color: `${c.text.link} !important`,
        },
        '& button, & button *': {
          color: `inherit`,
        },
        '& svg, & svg *': {
          color: `inherit`,
        },
        '& .MuiPaper-root': {
          backgroundColor: `${c.background.paper} !important`,
        },
        '& .MuiCard-root': {
          backgroundColor: `${c.background.paper} !important`,
        },
      }),
    },
  };
});

export const PluginTabWrapper = ({ children }: { children: ReactNode }) => {
  const appThemeApi = useApi(appThemeApiRef);
  const themeId = useObservable(appThemeApi.activeThemeId$());
  const isV2Theme = themeId?.startsWith('odp-v2-') ?? false;

  const { classes } = useStyles({ isV2Theme });
  return <div className={classes.root}>{children}</div>;
};
